import { useEffect, useRef, useState } from "react";
import { useApp } from "@/context/AppContext";
import { currentShift } from "@/lib/shift";
import { printElement } from "@/lib/print";
import { uuid } from "@/lib/format";

// Printers configured to "open drawer on print" pop the drawer when this tiny ticket is printed.
export default function DrawerKick() {
  const { t, view, dispatch } = useApp();
  const ctx = useRef({});
  ctx.current = { view, dispatch };
  const [on, setOn] = useState(false);
  useEffect(() => {
    const h = (e) => {
      const sh = currentShift(ctx.current.view);
      if (e.detail?.manual && sh) ctx.current.dispatch("cash.move", { id: uuid(), shift_id: sh.id, kind: "open", amount: 0, reason: "no sale" });
      setOn(true);
    };
    window.addEventListener("tpv:drawer", h);
    return () => window.removeEventListener("tpv:drawer", h);
  }, []);
  useEffect(() => {
    if (!on) return undefined;
    document.body.classList.add("printing-drawer");
    const id = setTimeout(() => { printElement(document.querySelector('[data-testid="drawer-ticket"]'), { receipt: true, title: 'cajon' }); document.body.classList.remove("printing-drawer"); setOn(false); }, 60);
    return () => clearTimeout(id);
  }, [on]);
  if (!on) return null;
  return (
    <div className="print-area drawer-ticket font-mono-receipt text-center text-xs" data-testid="drawer-ticket">
      <div>{view.shop?.name}</div>
      <div>{t("open_drawer")} · {new Date().toLocaleString("en-GB")}</div>
    </div>
  );
}
